import { getDateRange } from 'src/Features/SelectedDatePeriod/predefinedDatePeriods'
import { getOrchestratedRacksAtLocations, getOrchestratedRacksWithIds } from 'src/Providers/OrchestratedRacks'
import { useAppStateStore } from 'src/Store/appState'
import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'
import type { AggregatedAssetParams } from 'src/Hooks/NetworkData/useAggregatedAssets'

export const useRacksWithAlarms = ({
  datePeriod,
  idType,
  ids,
  onlyWithAlarms = false,
  enableAllAlarmTypes = false,
  enabled = true,
}: AggregatedAssetParams) => {
  const lastUpdated = useAppStateStore(state => state.selectedDatePeriod.lastUpdated)

  const query = useQueryWithErrorHandling(
    ['racksWithAlarms', { idType, ids, datePeriod, onlyWithAlarms, enableAllAlarmTypes, lastUpdated, enabled }],
    () => {
      if (!datePeriod || !enabled) {
        return []
      }
      const dateRange = getDateRange(datePeriod)
      if (idType === 'baneDataLocationIds') {
        return getOrchestratedRacksAtLocations(dateRange, ids, onlyWithAlarms, enableAllAlarmTypes)
      }

      return getOrchestratedRacksWithIds(dateRange, ids, onlyWithAlarms, enableAllAlarmTypes)
    },
    {
      enabled: ids.length > 0,
    },
    'racks.fetchError'
  )

  return {
    ...query,
    racksWithAlarms: query.data,
  }
}
